<template>
  <div>
      <div class="grid-x grid-padding-x align-center">
          <div class="cell text-center confirm">
              <i class="material-icons">check_circle</i>
              <h3>{{ $t('label.emailVerification') }}</h3>
              <p>
                {{ $t('label.emailVerificationSuccess') }}
              </p>
          </div>
      </div>

      <div class="grid-x grid-padding-x">
        <div class="cell small-12 text-right">
          <p>
            <router-link to="/" class="link-underline">
              {{ $t('label.backLogin') }}
            </router-link>
          </p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'register'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/VerifySuccess.vue